var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12759_59174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6135 9.68229V5.04343C15.6135 2.26789 13.2647 0.00976562 10.3775 0.00976562C7.49034 0.00976562 5.14149 2.26789 5.14149 5.04343H6.2941C6.2941 2.87883 8.12589 1.11783 10.3775 1.11783C12.6291 1.11783 14.4609 2.87883 14.4609 5.04343V8.56852C13.3348 7.71919 11.9166 7.21219 10.3775 7.21219C6.7231 7.21219 3.75 10.0704 3.75 13.5836C3.75 17.0968 6.7231 19.955 10.3775 19.955C14.0319 19.955 17.005 17.0968 17.005 13.5836C17.005 12.115 16.4852 10.7611 15.6135 9.68229ZM10.3775 18.8469C7.35865 18.8469 4.90261 16.4858 4.90261 13.5836C4.90261 10.6814 7.35865 8.32026 10.3775 8.32026C13.3964 8.32026 15.8524 10.6814 15.8524 13.5836C15.8524 16.4858 13.3964 18.8469 10.3775 18.8469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3775 10.9141C9.45301 10.9141 8.70093 11.6371 8.70093 12.5258C8.70093 13.2199 9.15972 13.813 9.80115 14.0394V15.6989H10.9538V14.0394C11.5951 13.813 12.054 13.2199 12.054 12.5258C12.054 11.6371 11.3019 10.9141 10.3775 10.9141ZM10.3775 13.0295C10.0886 13.0295 9.85354 12.8035 9.85354 12.5258C9.85354 12.2481 10.0886 12.0221 10.3775 12.0221C10.6664 12.0221 10.9014 12.2481 10.9014 12.5258C10.9014 12.8035 10.6664 13.0295 10.3775 13.0295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12759_59174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.747,
    height: 19.9452,
    fill: "white",
    transform: "translate(0.00402832 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockUnlock);
export default __webpack_public_path__ + "static/media/padlock_unlock.496ac662a51a68ae3ca8beaad594f0b5.svg";
export { ForwardRef as ReactComponent };